<template>
    <div class="pthv-form pthv-poi-types-wrapper">
        <div class="pthv-poi-type" v-for="poiType in poiTypes">
            <input 
                type="checkbox" 
                v-model="poiTypesChecked" 
                :title="poiType.name" 
                :id="poiType.tid" 
                :value="poiType.tid" 
                :ref="poiType.tid" 
                :name="poiType.tid" 
            />
            <label :for="poiType.tid">{{ poiType.name }}</label>
        </div>
    </div>
</template>

<script>
    import getPoiTypes from "../lib/poi/getPoiTypes.ts";

    export default {
        name: "ApthPoiTypes",
        created() { 
            getPoiTypes(this.siteBasePath, this.network).then(data => {
                this.setPoiTypes(data);
            });
        },
        data() {
            return {
                poiTypes: [],
                poiTypesChecked: []
            };
        },
        watch: {
            // Watch changes on checkboxes and send an event to parent component
            poiTypesChecked(newPoiTypesChecked, oldPoiTypesChecked) {
                this.$emit("selectpoitype", newPoiTypesChecked);
            }
        },
        props: {
            siteBasePath: {
                type: String,
                required: true
            },
            network: {
                type: String,
                required: true
            },
        },
        methods: {
            setPoiTypes: function(poiTypes) {
                this.poiTypes = poiTypes;
                this.$emit("poitypesready", poiTypes);
                this.poiTypesChecked = this.poiTypes.filter((poiType) => {
                    return (poiType.checked == 1);
                }).map((poiType) => {
                    return poiType.tid;
                });
            },
        }
    };
</script>

<style>
.pthv-poi-types-wrapper {
    font-weight: bold;
}
.pthv-poi-type {
    margin-block: 0.5rem;
}
</style>